import { all, call, put, takeLatest } from "redux-saga/effects";
import jwtDecode from "jwt-decode";
import { encode } from "base-64";
import moment from "moment";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get(action) {
    const { password, username, idToken } = action.payload;
    let accountUrl;
    const authUrl = `${config.auth.url}?app_client_id=${config.auth.appClientId}`;
    const loggingUrl = `${config.auth.logging}`;

    try {
        let token = "";

        /** Track event before token */

        if (!idToken) {
            const auth = yield call(http.anonymous.get, authUrl, {
                Authorization: `Basic ${encode(`${username}:${password}`)}`,
            });
            token = auth.data.idToken;
        } else token = idToken;

        /** Before JWT */

        const { exp, sub } = jwtDecode(token);

        /** After JWT */

        accountUrl = `${config.api.baseUrl}${config.api.paths.me}?identity_id=${sub}`;

        const account = yield call(http.anonymous.get, accountUrl, {
            Authorization: `Bearer ${token}`,
        });

        const authData = {
            idToken: token,
            account: account.data[0],
            expiryDate: moment.unix(exp).utc(),
            identityId: sub,
            username,
        };

        yield put(actionCreators.getSuccess(authData));
        const authString = JSON.stringify(authData);
        // update storage with recent Authentication
        localStorage.setItem("persist:root", authString);
    } catch (error) {
        const errStr = error.toString();
        logToSentry("auth login", { error, errStr, authUrl, accountUrl });
        yield put(actionCreators.getFailure(errStr));
    }
}

function* getBlobSasToken(action) {
    const { containerName } = action.payload;
    const url = `${config.auth.sasToken}`;

    try {
        const auth = yield call(http.authorized.post, url,{"container_name":containerName});
        const { data } = auth;
        yield put(actionCreators.getSasTokenSuccess(data));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("blob sas token ", {
            error,
            errStr,
        });
        yield put(actionCreators.getSasTokenFailure(errStr));
    }
}

function* logout() {
    try {
        localStorage.setItem("persist:root", "{}");
    } catch (error) {
        const errStr = error.toString();
        console.log(error);
        logToSentry("Logout", {
            error,
            errStr,
        });
        yield put(actionCreators.getFailure(errStr));
    }
}

export { get, logout };

export default (function* () {
    yield all([
        takeLatest(actionTypes.AUTH_GET_REQUEST, get),
        takeLatest(actionTypes.GET_SAS_TOKEN, getBlobSasToken),
        takeLatest(actionTypes.AUTH_LOGOUT, logout),
    ]);
})();
